<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật : {{ modelData.name }}<!--  / Khóa : {{ configData.course.name | courseName }} / {{ configData.chapter.name }} --></h2>
        <el-button @click="backModel" size="small" class="btn-back">
          Trờ về <!-- : {{ configData.course.name | courseName }} / {{ configData.chapter.name }} -->
        </el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel" @submit.native.prevent>
            <el-form-item prop="name" label="Tên bài học" class="form-item">
              <el-input disabled v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
            </el-form-item>
            <!-- <el-form-item prop="time_video_txt" label="Thời gian video" class="form-item">
              <el-input disabled v-model="modelData.time_video_txt" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="link_video" label="Link video (mã Embemd của video Vimeo)" class="form-item">
              <el-input disabled v-model="modelData.link_video" type="textarea" class="input-seach"></el-input>
            </el-form-item> -->
            <el-form-item prop="lesson_content" label="Nội dung bài học">
              <tinymce
                id="d1"
                v-model="modelData.lesson_content"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '100px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item prop="lesson_document" label="Tài liệu bài học">
              <tinymce
                id="d2"
                v-model="modelData.lesson_document"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '100px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item prop="priority" label="Ưu tiên" class="form-item">
              <el-input v-model="modelData.priority" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
              <el-button
                :disable="!canSubmit"
                :loading="!canSubmit"
                type="warning"
                size="small"
                @click="submitForm('createModel')">Cập nhật</el-button>
              <el-button
                size="small"
                class="btn-back"
                @click="backModel">Trở về
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'LessonUpdate',
  metaInfo () {
    return {
      title: 'Bài học | Cập nhật'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        chapter_id: '',
        time_video: '',
        time_video_text: '',
        link_video: '',
        lesson_content: '',
        lesson_document: '',
        status: true
      },
      configData: {
        course: {
          id: 0,
          name: 'Tên khóa này'
        },
        chapter: {
          id: 0,
          name: 'Tên chương này'
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên bài học' },
          { min: 2, max: 191, message: 'Tên bài học có chiều dài từ 2 tới 191 kí tự' }
        ],
        link_video: [
          { required: true, message: 'Vui lòng nhập link video' }
        ]
      }
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.fetchModel()
    this.configDataAndBreadcrumb()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình dữ liệu về khóa học, bài, cấu hình Breadcrumb
    configDataAndBreadcrumb () {
      this.modelData.chapter_id = this.$route.params.chapter_id
      this.fetchCourse()
    },
    fetchCourse () {
      axios.get('courses/' + this.$route.params.course_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.course = response.data
            this.fetchChapter()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchChapter () {
      axios.get('chapters/' + this.$route.params.chapter_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.chapter = response.data
            this.configBreadcrumb()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-show', course_id: this.$route.params.course_id, text: this.configData.course.name },
        { name: 'chapters-show', course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id, text: this.configData.chapter.name },
        { name: 'chapters-index', text: 'Cập nhật bài học' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'chapters-show', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('lessons/' + this.$route.params.lesson_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      axios.put('lessons/' + this.$route.params.lesson_id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật bài học thành công',
              type: 'success'
            })
            this.$router.push({name: 'chapters-show', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/lessons/Update.vue